module.exports = new __parcel__URL__("marine-sm.3359b02a.jpg").toString();